angular.module("thor.shared.sale-publish.items-publish-summary.component", []).component("itemsPublishSummary", {
    bindings: {
        isSaleOnline: "<",
        itemsPublishSummary: "<"
    },
    controller: class {
        public isSaleOnline: boolean = false;
        public itemsPublishSummary;
    },
    template: require("./items-publish-summary.html")
});
